import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, ADD, EDIT } from "const"
import { StateType, hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_RRS_CATEGORY,
    StoreType,
    RrsCategoryProps,

    LoadAllRrsCategories,
    LoadRrsCategoryById,

    setRrsCategoryList,
    setRrsCategoryChildParent,
    setRrsCategoryEdit,
    setRrsCategoryReloadEdit,
    initRrsCategory,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import AccessDenied from "client/parts/accessDenied"
import Form from "./form"

const Edit = ({
    categoryId = null,
}: RrsCategoryProps) => {
    const category = useSelector((state: StoreType) => state.rrsCategory.categoryEdit)
    const reloadEdit = useSelector((state: StoreType) => state.rrsCategory.reloadEdit)

    const project = useSelector((state: StoreType) => state.project.projectView)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setRrsCategoryReloadEdit(false))
        setTimeout(() => {
            dispatch(setRrsCategoryReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        const promiseArray: Promise<any>[] = [
            LoadAllRrsCategories(userData.accountId, project.id).then((res) => {
                dispatch(setRrsCategoryList(res.categoryList))
                dispatch(setRrsCategoryChildParent(res.childParent))
            }),
        ]

        if (categoryId === 0) {
            dispatch(setRrsCategoryEdit(initRrsCategory))
        } else {
            promiseArray.push(
                LoadRrsCategoryById(categoryId, userData.accountId, project.id).then((res) => {
                    dispatch(setRrsCategoryEdit({
                        ...res,
                        customVariablesParsed: res.customVariables ? JSON.parse(res.customVariables) : null,
                    }))
                }),
            )
        }

        setLoadState(PENDING)
        Promise.all(promiseArray).then(() => {
            setLoadState(IDLE)
            reload()
        })
    }, [])

    const addAccess = !project.id
        ? hasAccess(PRM_RRS_CATEGORY, ADD)
        : hasProjectAccess(PRM_RRS_CATEGORY, ADD)

    const editAccess = !project.id
        ? hasAccess(PRM_RRS_CATEGORY, EDIT)
        : hasProjectAccess(PRM_RRS_CATEGORY, EDIT)

    if (!category) return <NotFound />
    if (categoryId === 0 && !addAccess) return <AccessDenied />
    if (categoryId !== 0 && !editAccess) return <AccessDenied />

    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {category.id ? lang.editCategory : lang.addCategory}
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form category={category} />
                }
                {
                    reloadEdit
                    && <Form category={category} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
